export const NAV = {
  logo: "nav-logo",
  metodo: "nav-link-metodo",
  casiStudio: "nav-link-casi-studio",
  perChiE: "nav-link-per-chi-e",
  chiSiamo: "nav-link-chi-siamo",
  hiringScan: "nav-link-hiring-scan",
  ctaCall: "nav-cta-prenota-call",
  mobileToggle: "nav-mobile-toggle",
};

export const HOME = {
  heroCtaPrimary: "home-hero-cta-primary",
  heroCtaSecondary: "home-hero-cta-secondary",
  statBlock: "home-stat-block",
  methodCard: "home-method-card",
  caseCard: "home-case-card",
  scanInput: "home-scan-input",
  scanSubmit: "home-scan-submit",
  footerCta: "home-footer-cta",
};

export const SCAN = {
  formRole: "scan-input-role",
  formSeniority: "scan-input-seniority",
  formSector: "scan-input-sector",
  formArea: "scan-input-area",
  formSize: "scan-input-size",
  submit: "scan-submit-btn",
  resultBlock: "scan-result-block",
  unlockNome: "scan-unlock-nome",
  unlockCognome: "scan-unlock-cognome",
  unlockAzienda: "scan-unlock-azienda",
  unlockEmail: "scan-unlock-email",
  unlockTel: "scan-unlock-tel",
  unlockSubmit: "scan-unlock-submit",
  feeResult: "scan-fee-result",
};

export const CONTACT = {
  nome: "contact-input-nome",
  cognome: "contact-input-cognome",
  azienda: "contact-input-azienda",
  email: "contact-input-email",
  telefono: "contact-input-telefono",
  ruolo: "contact-input-ruolo",
  submit: "contact-submit-btn",
};

export const CASE = {
  filter: "case-filter",
  card: "case-card",
  detailBack: "case-detail-back",
};

export const VERTICAL = {
  cta: "vertical-cta",
};
